export default {
  title: 'giftChooseContent.title',
  buttons: [
    {
      timeout: 1000,
      text: 'giftChooseContent.buttons.0.text',
      className: 'custom-button gift-choose__button',
      action: 'send',
    },
    {
      timeout: 1000,
      text: 'giftChooseContent.buttons.1.text',
      className: 'custom-button custom-button_gray gift-choose__button gift-choose__button_last',
      action: 'close',
    },
  ],
  sendModal: {
    title: 'giftChooseContent.sendModal.title',
    buttons: [
      {
        timeout: 1000,
        text: 'giftChooseContent.sendModal.buttons.0.text',
        className: 'custom-button wish-gift-card__button custom-button_wish-coin',
      },
      {
        disposable: true,
        text: 'giftChooseContent.sendModal.buttons.1.text',
        className: 'custom-button_gray wish-gift-card__button',
        modalData: { action: 'close', data: { type: 'current' } },
      },
    ],
  },
};
